<template>
  <footer class="w-full px-6 md:px-10 mt-16">
    <div class="max-w-container-ws">
      <div class="flex flex-wrap lg:flex-nowrap justify-between py-14 lg:py-24">
        <div class="lg:w-1/3 mb-20">
          <span class="text-4xl block mb-3">Terreiro de Umbanda Vó Rita das Almas</span>
            <span class="text-lg text-left">
            Caridade sem ela não há salvação
          </span>
        </div>
        <div class="flex contact w-full lg:w-auto flex-wrap">
          <div class="lg:mx-4 w-full mb-8">
            <span class="font-bold mb-3 block">{{ $t('ADDRESS') }}</span>
            <span class="block">
              Rua Jacareí, n° 76, Parque Nossa Senhora da Glória. Tremembé, São Paulo, 12.120-204.
            </span>

            <!-- Social networks -->
             <div class="my-3 block w-full">
               <!-- <a href="https://www.instagram.com/terreirovoritadasalmas" target="_blank" class="hover:opacity-60">
                <font-awesome :icon="faInstagram" font-size="28px"/>
               </a> -->
             </div>
          </div>
          <div class="flex flex-col flex-1 mb-8">
            <span class="font-bold  mb-3 block">{{ $t('CONTACT_US') }}</span>
            <a href="mailto:contato@terreirovoritadasalmas.com.br">
              contato@terreirovoritadasalmas.com.br
            </a>
          </div>
        </div>
      </div>
      <div class="x-dividir my-4 block" />
      <div class="flex justify-between py-6 flex-wrap">
        <ul class="flex flex-row w-full my-2 lg:w-auto justify-center">
          <li
            class="mr-4"
            v-for="(link, idx) in links">
            <nuxt-link
              :key="idx"
              :to="link.href"
            >
              {{ link.name }}
            </nuxt-link>
          </li>
        </ul>
        <span class="text-center w-full my-2 lg:w-auto lg:text-left">
          Terreiro de Umbanda Vó Rita das Almas - Todos os direitos reservados
        </span>
      </div>
    </div>
  </footer>
</template>
<script lang="ts" setup>
// Packages
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

// -------------------------------------------
// Context
// -------------------------------------------

const { t } = useI18n();

const links = [
  {
    name: t('BLOG'),
    href: '/blog',
  },
  {
    name: t('EVENTS'),
    href: '/events',
  },
  {
    name: t('FAQS'),
    href: '/faqs',
  },
];

</script>
<style lang="scss" scoped>
footer {
  min-height: 489px;
  justify-items: flex-end;

  > div {
    margin-right: auto;
    margin-left: auto;
  }

  .x-dividir {
    height: 1px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .contact > div {
    display: block;
    width: 300px;
  }
}
</style>